import { useContext } from "react";
import { SuccessModalContext, type SuccessModalContextValue } from "./SuccessModalProvider";

/** Access `showSuccess`. Must be called within a SuccessModalProvider. */
export function useSuccessModal(): SuccessModalContextValue {
  const ctx = useContext(SuccessModalContext);
  if (!ctx) throw new Error("useSuccessModal must be used within a SuccessModalProvider");
  return ctx;
}
